/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListEnvironmentsSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type ListEnvironmentsRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListEnvironmentsSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListEnvironmentsSecurity$outboundSchema: z.ZodMiniType<
  ListEnvironmentsSecurity$Outbound,
  ListEnvironmentsSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listEnvironmentsSecurityToJSON(
  listEnvironmentsSecurity: ListEnvironmentsSecurity,
): string {
  return JSON.stringify(
    ListEnvironmentsSecurity$outboundSchema.parse(listEnvironmentsSecurity),
  );
}

/** @internal */
export type ListEnvironmentsRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListEnvironmentsRequest$outboundSchema: z.ZodMiniType<
  ListEnvironmentsRequest$Outbound,
  ListEnvironmentsRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function listEnvironmentsRequestToJSON(
  listEnvironmentsRequest: ListEnvironmentsRequest,
): string {
  return JSON.stringify(
    ListEnvironmentsRequest$outboundSchema.parse(listEnvironmentsRequest),
  );
}
